export default "/_next/static/fonts/Graphik-SemiboldItalic-3cc714464c4dda0bdd55b34acf6d6d34.woff2";